export const reloadTable = (newProps, props) => {
  const {
    pagination: newPagination = {},
    order: newOrder = {},
    term: newTerm = '',
    filter: newFilter = ''
  } = newProps
  const { pagination = {}, order = {}, term = '', filter = '' } = props

  if (
    newOrder.column !== ((order || {}).column || '') ||
    newOrder.direction !== ((order || {}).direction || 1)
  ) {
    return true
  }

  if (
    newPagination.page !== pagination.page ||
    newPagination.rowsPerPage !== pagination.rowsPerPage
  ) {
    return true
  }

  if (newTerm !== term || filter !== newFilter) {
    return true
  }

  return false
}

export default reloadTable



// WEBPACK FOOTER //
// ./src/utils/reloadTable.js